import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  CommonPaginationConfig,
  CrudService, CrudType,
  LoggedInUserModel,
  ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR,
  ResponseMessageTypes, RxjsService, SnackbarService,
  addDefaultTableObjectProperties,
  currentComponentPageBasedPermissionsSelector$,
  prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams
} from '@app/shared';
import { MomentService } from '@app/shared/services/moment.service';
import { CollectionModuleApiSuffixModels } from '@modules/collection';
import { MY_TASK_COMPONENTS } from '@modules/my-tasks/shared/utils/task-list.enum';
import { loggedInUserData } from '@modules/others';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-billing-doa-dashboard',
  templateUrl: './billing-doa-dashboard.component.html'
})
export class BillingDOADashboardComponent extends PrimeNgTableVariablesModel implements OnInit {
  permission = [];

  constructor(
    private store: Store<AppState>, private router: Router, private snackbarService: SnackbarService,
    private rxjsService: RxjsService, private crudService: CrudService, private momentService: MomentService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Billing DOA Dashboard",
      breadCrumbItems: [{ displayName: 'My Task', relativeRouterUrl: '' },
      { displayName: 'Billing DOA Dashboard' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Billing DOA Dashboard',
            dataKey: 'ownershipChargesConfigId',
            enableSecondHyperLink: true,
            cursorSecondLinkIndex: 6,
            columns: [{ field: 'requestNo', header: 'Request No', width: '120px' },
            { field: 'requestDate', header: 'Request Date', width: '120px' },
            { field: 'departmentName', header: 'Department', width: '120px' },
            { field: 'processTypeName', header: 'Process Name', width: '120px' }, { field: 'processDescription', header: 'Path Description', width: '120px' },
            { field: 'transactionTypeName', header: 'Transaction Type', width: '120px' },
            { field: 'customerRefNo', header: 'Customer ID', width: '120px' },
            { field: 'customerName', header: 'Customer Name', width: '120px' },
            { field: 'transactionRefNo', header: 'Transaction ID', width: '120px' }, { field: 'esclationType', header: 'Escalation Type', type: "dropdown", width: '120px', options: [{ value: false, label: 'Value' }, { value: true, label: 'Percentage' }] },
            { field: 'esclationAmount', header: 'Escalation Amount', width: '120px' ,shouldShowTextField:true, validateInput:this.isANumberWithZero}, { field: 'creatorUserName', header: 'Creator Username', width: '120px' },
            { field: 'lastUserName', header: 'Last Username', width: '120px' },
            { field: 'currentUserName', header: 'Current User', width: '120px' }, { field: 'onLevel', header: 'On Level', width: '120px' ,shouldShowTextField:true, validateInput:this.isANumberWithZero},
            { field: 'levelName', header: 'Level Name', width: '120px' },
            { field: 'status', header: 'Status', width: '120px' }, { field: 'actionDateAndTime', header: 'Action Date/Time', width: '120px' }],
            apiSuffixModel: CollectionModuleApiSuffixModels.BALANCE_OF_CONTRACT_DOA_DASHBOARD,
            moduleName: ModulesBasedApiSuffix.COLLECTIONS,
          },
        ]
      }
    }
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties,[{index:0,propertyName:'enableAddActionBtn'}]);
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getBillingDOAList();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.permission = response[1][MY_TASK_COMPONENTS.BILLING_DOA]
      if (this.permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, this.permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  onActionSubmitted(e) {
    if (e.data && !e.search && !e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data);
    } else if (e.data && e.search && !e?.col) {
      this.onCRUDRequested(e.type, e.data, e.search);
    } else if (e.type && !e.data && !e?.col) {
      this.onCRUDRequested(e.type, {});
    } else if (e.type && e.data && e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data, e?.col);
    }
  }

  getBillingDOAList(pageIndex?: string, pageSize?: string, otherParams?: object) {
    if (!otherParams) {
      otherParams = {};
    }
    otherParams['roleId'] = this.loggedInUserData.roleId;
    otherParams['userId'] = this.loggedInUserData.userId;
    this.loading = true;
    let collectionModuleApiSuffixModels: CollectionModuleApiSuffixModels;
    collectionModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.crudService.get(
      ModulesBasedApiSuffix.COLLECTIONS,
      collectionModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        this.dataList = response.resources;
        this.totalRecords = response.resources.length;
      } else {
        this.dataList = [];
        this.totalRecords = 0;
      }
      this.reset = false;
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCRUDRequested(type: CrudType | string, row?, unknownVar?): void {
    switch (type) {
      case CrudType.GET:
        let otherParams = {};
        if (Object.keys(row).length > 0 && row['searchColumns']) {
          Object.keys(row['searchColumns']).forEach((key) => {
            if (key.toLowerCase().includes('date')) {
              otherParams[key] = this.momentService.localToUTC(row['searchColumns'][key]);
            }
            else {
              otherParams[key] = row['searchColumns'][key];
            }
          });
        }
        let pageIndex, maximumRows;
        if (!row['maximumRows']) {
          maximumRows = CommonPaginationConfig.defaultPageSize;
          pageIndex = CommonPaginationConfig.defaultPageIndex;
        }
        else {
          maximumRows = row["maximumRows"];
          pageIndex = row["pageIndex"];
        }
        delete row['maximumRows'] && row['maximumRows'];
        delete row['pageIndex'] && row['pageIndex'];
        delete row['searchColumns'];
        this.getBillingDOAList(pageIndex, maximumRows, { ...otherParams, ...row });
        break;
      case CrudType.VIEW:
        if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canApprove) {
          this.openAddEditPage(CrudType.VIEW, row);
        }
        else {
          this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        break;
      case CrudType.EDIT:
        this.rxjsService.setViewCustomerData({
          customerId: row['customerId'],
          addressId: row['addressId'],
        })
        this.rxjsService.navigateToViewCustomerPage();
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | any, index?: number): void {
    switch (type) {
      case CrudType.VIEW:
        if (editableObject.processTypeName == 'Balance of Contract Escalation') {
          this.router.navigate([`/my-tasks/billing-DOA/balance-of-contract/approval`], { queryParams: { id: editableObject.balanceOfContractId } });
        }
        else if (editableObject.processTypeName == 'Purchase of Alarm System Escalation') {
          this.router.navigate([`/my-tasks/billing-DOA/purchase-of-alarm-system/approval`], { queryParams: { id: editableObject.balanceOfContractId } });
        }
        break;
    }
  }
}
